import { render, staticRenderFns } from "./ModalPurchase.vue?vue&type=template&id=53a3d287"
import script from "./ModalPurchase.vue?vue&type=script&lang=js"
export * from "./ModalPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports